import { PreviewStatementDatasetSource } from "../previewTypes";

export const EXPENSE_BY_VENDOR_DATASET: PreviewStatementDatasetSource = {
    shape: "statement",
    accountHeader: "Vendor",
    percentHeader: "% of total",
    percentBase: 1500000,
    rows: [
        {
            id: "aws",
            label: "Amazon Web Services",
            kind: "line",
            amount: 548000,
        },
        {
            id: "contract-labor",
            label: "Contract Labor Collective LLC",
            kind: "line",
            amount: 296400,
        },
        {
            id: "wework",
            label: "WeWork",
            kind: "line",
            amount: 186000,
        },
        {
            id: "delta",
            label: "Delta Air Lines",
            kind: "line",
            amount: 124350,
        },
        {
            id: "adobe",
            label: "Adobe",
            kind: "line",
            amount: 62750,
        },
        {
            id: "staples",
            label: "Staples",
            kind: "line",
            amount: 3420,
        },
        {
            id: "refund",
            label: "Returned Equipment Credit",
            kind: "line",
            amount: -27000,
        },
        {
            id: "unused-vendor",
            label: "Unused Vendor",
            kind: "line",
            amount: 0,
        },
        {
            id: "office-depot",
            label: "Office Depot",
            kind: "line",
            amount: 0,
            hasActivity: true,
        },
        {
            id: "others",
            label: "Others",
            kind: "line",
            amount: 306080,
        },
        {
            id: "total",
            label: "Total",
            kind: "total",
            amount: 1500000,
            hasTopBorder: true,
        },
    ],
};
